<mat-form-field 
 *ngIf="objets !== undefined && parentForm && myControl" 
  class="no-padding"  
  [matTooltip]="libelleControl.value" 
  appearance="fill" 
  [floatLabel]="auto"
  style="margin-bottom: -20px"  [formGroup]="parentForm">
      <input type= "text"
        matInput
        [required]="util.hasRequiredField(myControl)"
        [formControl]="myControl"
        [placeholder]="placeholder"
        [matAutocomplete]="auto"
        (change)="$event.target.value === '' ? deleteIfEmpty(): null">
    <mat-autocomplete 
      autoActiveFirstOption 
      panelWidth="auto"
      #auto="matAutocomplete"
      (optionSelected)="onObjetChange($event)">
      <mat-option *ngFor="let obj of filteredObjets | async" [value]="obj"> {{obj}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="myControl.hasError('forbiddenNames')">
      Veuillez sélectionner une valeur suggérée
    </mat-error>
    <mat-error *ngIf="myControl.hasError('required')">
      Veuillez sélectionner une valeur
    </mat-error>
</mat-form-field>
